import Swiper, { Autoplay, Navigation, Pagination, Thumbs } from "swiper";
/**
 * @param swiperInit
 */
export default function swiperInit() {
	var SectionSlideHome = new Swiper(".section-home-banner .swiper", {
		spaceBetween: 0,
		slidesPerView: 1,
		modules: [Pagination, Autoplay],
		autoplay: {
			delay: 3500,
		},
		speed: 800,
		pagination: {
			el: ".section-home-banner .swiper-pagination",
			clickable: true,
		},
	});
	$(".swiper-home-product-hot").each(function (index) {
		const isDisable = !!$(this).parents(".section-swiper-product").length;
		if (window.matchMedia("(max-width: 767.8px)").matches && isDisable) return;
		const nameClass = "product_section_" + index;
		$(this).addClass(nameClass);
		new Swiper(`.${nameClass} .swiper`, {
			slidesPerView: "auto",
			modules: [Navigation],
			slidesPerGroup: 1,
			spaceBetween: 0,
			speed: 600,
			breakpoints: {
				768: {
					spaceBetween: 20,
				},
				1024: {
					spaceBetween: 30,
				},
			},
			navigation: {
				nextEl: `.${nameClass} .btn-next`,
				prevEl: `.${nameClass} .btn-prev`,
			},
		});
	});
	var ProductImageThumb = new Swiper(".section-product-detail .wrap-slide-image-thumb .swiper", {
		slidesPerView: "auto",
		spaceBetween: 10,
		watchOverflow: true,
		breakpoints: {
			575: {
				spaceBetween: 15,
				slidesPerView: "auto",
			},
			1024: {
				spaceBetween: 15,
				slidesPerView: "auto",
			},
			1280: {
				spaceBetween: 15,
				slidesPerView: "auto",
			},
		},
	});
	ProductImageThumb.on("resize", function (instance) {
		element.classList.toggle(".slider-active", instance.virtualSize > instance.size);
	});
	var ProductImageMain = new Swiper(".section-product-detail .wrap-slide-image-main .swiper", {
		spaceBetween: 10,
		speed: 500,
		modules: [Navigation, Thumbs],
		rewind: true,
		slidesPerView: 1,
		navigation: {
			nextEl: ".section-product-detail  .btn-next",
			prevEl: ".section-product-detail  .btn-prev",
		},
		thumbs: {
			swiper: ProductImageThumb,
		},
	});
	new Swiper(".section-home-8 .swiper", {
		slidesPerView: 1.5,
		spaceBetween: 15,
		modules: [Navigation],
		navigation: {
			nextEl: ".section-home-8 .btn-next",
			prevEl: ".section-home-8 .btn-prev",
		},
		breakpoints: {
			1024: {
				spaceBetween: 30,
				slidesPerView: 3,
			},
			1280: {
				spaceBetween: 30,
				slidesPerView: 4,
			},
		},
	});
	new Swiper(".box-discover-frame .slide-mockup>.swiper", {
		slidesPerView: 1.5,
		spaceBetween: 15,
		modules: [Navigation],
		navigation: {
			nextEl: ".box-discover-frame .slide-mockup .btn-next",
			prevEl: ".box-discover-frame .slide-mockup .btn-prev",
		},
		breakpoints: {
			1024: {
				spaceBetween: 30,
				slidesPerView: 3,
			},
			1280: {
				spaceBetween: 30,
				slidesPerView: 2.8,
			},
		},
	});
	const popupMockupThumb = new Swiper("#popup-image-mockup .swiper-thumb", {
		spaceBetween: 10,
		slidesPerView: 5,
		observer: true,
		observeParents: true,
		breakpoints: {
			768: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 5,
			},
		},
	});
	const popupMockup = new Swiper("#popup-image-mockup .swiper-main", {
		slidesPerView: 1,
		spaceBetween: 20,
		observer: true,
		observeParents: true,
		modules: [Thumbs],
		freeMode: true,
		thumbs: {
			swiper: popupMockupThumb,
		},
	});
	window[`popupMockupThumb`] = popupMockupThumb;
	window[`popupMockup`] = popupMockup;
}
